import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import PostByAgg from '../../utils/axios';
import { useAuth } from '../../context/AuthContext';
import ModalAlert from '../../components/ModalAlert';
import LottieLoading from '../../components/child/LottieLoading';

const UsersForm = ({ open, mode, user, handleClose, refreshData,onClose }) => {
    const [formData, setFormData] = useState(user || {}); // Initialize form data
    const { musicLabelCode } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(<div></div>);
    // Handle mode-specific behaviors (e.g., view mode)
    useEffect(() => {
        if (user) {
            setFormData(user); // Update form data when user is selected
        }
    }, [user]);

    const handleDelete = () => {
        // Logic for deleting the user
        console.log('Deleting user:', user);
        handleClose(); // Close the modal after delete
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (mode === 'create') {
            const url = 'user/um/v1/user-admin-label-registration';
            PostByAgg({
                url,
                body: {
                    "music_label_code": musicLabelCode,
                    "user_name": formData.username,
                    "full_name": formData.full_name,
                    "email": formData.email,
                    "description": formData.description,
                    "created_by": musicLabelCode,
                },
                onResponse: onResponseCreate,
                onError: onResponseErrorCreate
            });
            function onResponseCreate(response) {
                setIsLoading(false)
                console.log("Response from create:", response.data)
                if(response.data.code === "2002000"){
                    setModal(
                        <ModalAlert
                            show={true}
                            type={"success"}
                            text={response.data.message.id}
                            action = {() => {
                                setModal(<div></div>);
                                refreshData();
                                onClose();
                            }}
                        />
                        
                    );
                }else{
                    setModal(
                        <ModalAlert
                            show={true}
                            type={"failed"}
                            text={response.data.message.id}
                            action = {() => {
                                onClose();
                            }}
                            />
                        );
    
                }
            }
            function onResponseErrorCreate(error) {
                console.log("Error from create:", error);
                setIsLoading(false);
                setModal(
                    <ModalAlert
                        show={true}
                        type={"failed"}
                        text={error.response.data.message.id}
                        action = {() => {
                            onClose();
                        }}
                        />
                )
            }
        } 
        // else if (mode === 'view') {
        //     // Handle view logic here (no need to submit)
        //     console.log('Viewing user:', formData);
        // }
    };

    return (
        <div
            className={`modal fade ${open ? "show" : ""}`}
            tabIndex="-1"
            style={{ display: open ? "block" : "none" }}
            aria-hidden={!open}
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header justify-content-between">
                        <h5 className="modal-title">{mode === 'create' ? 'Create User' : mode === 'view' ? 'View User' : 'Delete User'}</h5>
                        <button type="button" className="close" onClick={handleClose}>
                            <Icon icon="mdi:close-circle" width={24} height={24} />
                        </button>
                    </div>
                    <div className="modal-body">
                        {mode === 'delete' ? (
                            <div>
                                <p>Are you sure you want to delete the user: <strong>{formData.name}</strong>?</p>
                                <div className="d-flex justify-content-end gap-2 mt-3">
                                    <button type="button" className="btn btn-danger" onClick={handleDelete}>
                                        Delete
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    {[
                                        { label: 'User Name', name: 'username' },
                                        { label: 'Full Name', name: 'full_name' },
                                        { label: 'Email', name: 'email' },
                                    ].map(({ label, name }) => (
                                        <div className="col-md-6 mb-3" key={name}>
                                            <label className="col-form-label" htmlFor={name}>
                                                {label}:
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id={name}
                                                name={name}
                                                value={formData[name] || ''}
                                                onChange={(e) => setFormData({ ...formData, [name]: e.target.value })}
                                                readOnly={mode === 'view'} // Make fields read-only in 'view' mode
                                                style={name === 'status_name' ? { backgroundColor: '#d4edda', color: '#ffff' } : {}}
                                            />
                                        </div>
                                    ))}
                                    <div className="d-flex justify-content-end gap-2 mt-3">
                                        {mode === 'create' && (
                                            <button type="submit" className="btn btn-primary">
                                                Create
                                            </button>
                                        )}
                                        {mode === 'view' && (
                                            <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                                Close
                                            </button>
                                        )}
                                    </div>
                                </div>
                                {modal}
                                {isLoading && <LottieLoading text="Loading..." />}
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UsersForm;
